module.exports = __webpack_public_path__ + "img/vehicle-restraints-no.33c3b4f4.svg";